import { googleEvent } from './GoogleAnalytics'

const pixelId = process.env.GATSBY_META_PIXEL_ID
const names = { page_view: 'PageView', search: 'Search', view_item: 'ViewContent', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout', add_payment_info: 'AddPaymentInfo', purchase: 'Purchase', sign_up: 'CompleteRegistration' }
const sentPurchases = new Set()

export function trackMeta(eventName, fields = {}) {
  if (process.env.NODE_ENV !== 'production' || !pixelId || typeof window === 'undefined' || typeof window.fbq !== 'function') return
  // Reuse the allowlisted commerce data, not arbitrary customer/API fields.
  const event = googleEvent(eventName, fields)
  const name = names[event?.event]
  if (!name) return
  const commerce = event.ecommerce
  const orderId = commerce?.transaction_id
  const key = `mdf_meta_purchase_${pixelId}_${orderId}`
  if (orderId) {
    if (sentPurchases.has(orderId)) return
    try { if (window.localStorage.getItem(key)) return } catch {}
  }
  const parameters = commerce ? {
    content_type: 'product',
    content_ids: commerce.items.map(item => item.item_id).filter(Boolean),
    contents: commerce.items.filter(item => item.item_id).map(item => ({ id: item.item_id, quantity: item.quantity, item_price: item.price })),
    num_items: commerce.items.reduce((sum, item) => sum + item.quantity, 0),
    currency: commerce.currency,
    ...(commerce.value !== undefined ? { value: commerce.value } : {})
  } : name === 'Search' ? { search_string: event.search_term } : {}
  if (orderId) {
    window.fbq('trackSingle', pixelId, name, parameters, { eventID: `purchase_${orderId}` })
    sentPurchases.add(orderId)
    try { window.localStorage.setItem(key, '1') } catch {}
  } else {
    window.fbq('trackSingle', pixelId, name, parameters)
  }
}
